import classNames from 'classnames';
import { FC } from 'react';

import styles from './TextField.styles.m.css';
import { ITextFieldProps } from './TextField.types';
import { getTextFieldHelperText } from './getTextFieldHelperText/getTextFieldHelperText';

export const TextField: FC<ITextFieldProps> = (props) => {
  const {
    className,
    input: { name, onChange, value, onFocus, onBlur },
    meta: { active, error, invalid, valid, dirty, modified, validating },
    label,
    placeholder,
    maxLength,
    isDisabled = false,
    helperText,
    validatingText,
    successText,
    setRef,
    readOnly = false,
    ignoreTrimError,
  } = props;

  const hasError =
    !validating && !!modified && !!invalid && !!(ignoreTrimError ? error : error.trim());
  const hasSuccess = !!successText && !validating && !!dirty && !!valid;
  const isValidating = !!validatingText && !!dirty && !!validating;

  const contentClasses = classNames(styles.content, {
    [styles.focused]: active,
    [styles.error]: hasError,
    [styles.success]: hasSuccess,
    [styles.disabled]: isDisabled,
    [styles.withLabel]: label,
    [styles.withPlaceholder]: label && placeholder,
  });

  const labelClasses = classNames(styles.label, {
    [styles.smallLabel]: active || !!placeholder || !!value,
    [styles.labelOver]: label && placeholder,
  });

  const placeholderClasses = classNames(styles.placeholder, {
    [styles.withPlaceholderLabel]: label && placeholder,
  });

  return (
    <div className={className}>
      <label className={contentClasses}>
        {label ? <span className={labelClasses}>{label}</span> : null}
        {placeholder && <span className={placeholderClasses}>{placeholder}</span>}
        <div className={styles.resizer}>
          <input
            name={name}
            onFocus={onFocus}
            onBlur={onBlur}
            className={styles.input}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            disabled={isDisabled}
            autoComplete="off"
            ref={setRef}
            readOnly={readOnly}
          />
          {placeholder && <span className={styles.hiddenPlaceholder}>{value}</span>}
        </div>
      </label>
      <div
        className={styles.helperText}
        data-test={`${name}-helper-text`}
      >
        {getTextFieldHelperText({
          isValidating,
          validatingText,
          hasError,
          errorText: error,
          hasSuccess,
          successText,
          helperText,
        })}
      </div>
    </div>
  );
};
